module.exports = __webpack_public_path__ + "static/media/theoryNotLogged.725dcd71.jpg";